import '.br{position:relative;}.ssr-plugin'
import '.i4{width:64px;}.ssr-plugin'
import '.i5{height:64px;}.ssr-plugin'
import '.bj{flex-shrink:0;}.ssr-plugin'
import '.k{position:absolute;}.ssr-plugin'
import '.i6{bottom:-4px;}.ssr-plugin'
import '.ck{right:-4px;}.ssr-plugin'
import '.e0{border-radius:50%;}.ssr-plugin'
import '.i7{border:2px solid var(--shades-white);}.ssr-plugin'
import '.o{overflow:hidden;}.ssr-plugin'
import '.i8{width:32px;}.ssr-plugin'
import '.i9{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="br i4 i5 bj"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="k i6 ck e0 i7 o i8 i9"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
